import { createSelector } from '@ngrx/store';
import { getStorePageState } from '../store.selectors';

export const getStoreOrdersState = createSelector(
  getStorePageState,
  (state) => state.ordersState
);
export const getOrdersIsLoading = createSelector(
  getStoreOrdersState,
  (orders) => orders.isLoading
);
export const getOrdersData = createSelector(
  getStoreOrdersState,
  (orders) => orders.data
);
export const getOrdersHasBeenFetched = createSelector(
  getStoreOrdersState,
  (orders) => orders.fetched
);
export const getOrdersError = createSelector(
  getStoreOrdersState,
  (orders) => orders.error
);
export const getOrdersSuccess = createSelector(
  getStoreOrdersState,
  (orders) => orders.success
);
